/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OffersSummaryInfo,
} from '../models/index';
import {
    OffersSummaryInfoFromJSON,
    OffersSummaryInfoToJSON,
} from '../models/index';

/**
 * 
 */
export class SummaryApi extends runtime.BaseAPI {

    /**
     */
    async getOffersSummaryInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OffersSummaryInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/summary/offers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OffersSummaryInfoFromJSON(jsonValue));
    }

    /**
     */
    async getOffersSummaryInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OffersSummaryInfo> {
        const response = await this.getOffersSummaryInfoRaw(initOverrides);
        return await response.value();
    }

}
